"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { analytics } from "lib/segment";

const BLOCKED_IPS = [
  "104.166.169.70",
  "115.240.143.68",
  "115.240.143.72",
  "13.39.2.166",
  "15.181.176.225",
  "15.254.38.106",
  "16.162.197.133",
  "20.171.60.120",
  "20.171.87.53",
  "20.118.170.138",
  "20.94.198.181",
  "203.126.165.78",
  "207.7.140.232",
  "23.90.171.74",
  "34.176.22.34",
  "4.228.82.142",
  "4.228.82.245",
  "4.37.0.135",
  "4.37.0.149",
  "4.37.0.152",
  "4.37.0.153",
  "4.37.0.159",
  "4.53.29.77",
  "4.59.33.67",
  "4.59.33.78",
  "4.59.33.81",
  "41.198.131.167",
  "5.254.100.22",
  "64.29.128.192",
  "64.29.128.238",
  "64.29.129.197",
  "64.29.129.199",
  "64.29.134.134",
  "64.29.134.151",
  "64.29.129.214",
  "64.29.135.142",
  "64.29.135.223",
  "76.9.210.85",
  "76.9.210.94",
  "77.246.180.158",
  "80.239.156.96",
  "94.46.130.85",
  "190.103.176.198",
  "190.103.176.215",
  "207.7.140.187",
  "223.70.241.7",
];

let robots = [
  "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/97.0.4692.71 Safari/537.36",
  "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.5993.70 Safari/537.36",
  "Mozilla/5.0 (compatible; TechTarget Analyzer/1.0; +http://techtarget.com/ )",
];

export default function Analytics() {
  const pathname = usePathname();
  const [isBlocked, setIsBlocked] = useState(true);

  useEffect(() => {
    async function fetchIP() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        const userAgent = navigator.userAgent;

        if (BLOCKED_IPS.includes(data.ip) || robots.includes(userAgent)) {
          setIsBlocked(true);
        } else {
          setIsBlocked(false);
        }
      } catch (error) {
        console.error("Failed to fetch IP address:", error);
      }
    }

    fetchIP();
  }, []);

  useEffect(() => {
    if (
      !isBlocked &&
      typeof window !== "undefined" &&
      (window.OnetrustActiveGroups == undefined ||
        window.OnetrustActiveGroups?.includes("2"))
    ) {
      analytics.page();
    }
  }, [pathname, isBlocked]);

  return null;
}
